import { render, staticRenderFns } from "./CustomThemeMaker.vue?vue&type=template&id=67a8b583"
import script from "./CustomThemeMaker.vue?vue&type=script&lang=js"
export * from "./CustomThemeMaker.vue?vue&type=script&lang=js"
import style0 from "./CustomThemeMaker.vue?vue&type=style&index=0&id=67a8b583&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports